export default __webpack_public_path__ + "static/media/reading.c111b27a4414c665791064b05b5c17c5.svg";